import { render, staticRenderFns } from "./Complexagon.vue?vue&type=template&id=fd46639c&"
import script from "./Complexagon.vue?vue&type=script&lang=js&"
export * from "./Complexagon.vue?vue&type=script&lang=js&"
import style0 from "./Complexagon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Complexagon.vue"
export default component.exports